import { render, staticRenderFns } from "./AdsCarouselIcon.vue?vue&type=template&id=a43e71a8&scoped=true"
import script from "./AdsCarouselIcon.vue?vue&type=script&lang=js"
export * from "./AdsCarouselIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a43e71a8",
  null
  
)

export default component.exports